import { arrayToBuffer, copyShallow, hasFeature, sleep } from '../helpers';
import * as clipboard from '../helpers/clipboard';
import { DialogController } from './dialog';
export class TroubleshootingController extends DialogController {
    static $inject = [
        '$scope', '$mdDialog', '$mdToast', '$translate',
        'CONFIG', 'LogService', 'BrowserService', 'ThemeService', 'WebClientService',
    ];
    $scope;
    $mdToast;
    $translate;
    config;
    logService;
    browserService;
    webClientService;
    log;
    sanitize = true;
    isSending = false;
    sendingFailed = false;
    description = '';
    constructor($scope, $mdDialog, $mdToast, $translate, config, logService, browserService, themeService, webClientService) {
        super($scope, $mdDialog, themeService);
        this.$scope = $scope;
        this.$mdToast = $mdToast;
        this.$translate = $translate;
        this.config = config;
        this.logService = logService;
        this.browserService = browserService;
        this.webClientService = webClientService;
        this.log = logService.getLogger('Troubleshooting-C');
    }
    get isConnected() {
        return this.webClientService.readyToSubmit;
    }
    get canSend() {
        return this.isConnected && this.description.length > 0 && !this.isSending;
    }
    async send() {
        this.isSending = true;
        this.sendingFailed = false;
        const log = new TextEncoder().encode(this.getLog(this.sanitize));
        const fail = () => {
            this.$scope.$apply(() => {
                this.isSending = false;
                this.sendingFailed = true;
                this.$mdToast.show(this.$mdToast.simple()
                    .textContent(this.$translate.instant('troubleshooting.REPORT_VIA_THREEMA_FAILED'))
                    .position('bottom center'));
            });
        };
        const support = {
            id: '*SUPPORT',
            type: 'contact',
        };
        if (!this.webClientService.contacts.has(support.id)) {
            try {
                await this.webClientService.addContact(support.id);
            }
            catch (error) {
                this.log.error('Unable to add contact *SUPPORT:', error);
                return fail();
            }
        }
        for (let i = 0; i < 50; ++i) {
            const contact = this.webClientService.contacts.get(support.id);
            if (hasFeature(contact, 8, this.log)) {
                break;
            }
            await sleep(100);
        }
        const browser = this.browserService.getBrowser();
        const message = {
            name: `webclient-${this.config.VERSION}-${browser.description('-')}.log`,
            fileType: 'text/plain',
            size: log.byteLength,
            data: arrayToBuffer(log),
            caption: this.description,
            sendAsFile: true,
        };
        try {
            await this.webClientService.sendMessage(support, 'file', message, { waitUntilAcknowledged: true });
        }
        catch (error) {
            this.log.error('Unable to send log report to *SUPPORT:', error);
            return fail();
        }
        this.isSending = false;
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(this.$translate.instant('troubleshooting.REPORT_VIA_THREEMA_SUCCESS'))
            .position('bottom center'));
        this.hide();
    }
    copyToClipboard() {
        const log = this.getLog(this.sanitize);
        let toastString = 'messenger.COPIED';
        try {
            clipboard.copyString(log, this.browserService.getBrowser().isSafari());
        }
        catch (error) {
            this.log.warn('Could not copy text to clipboard:', error);
            toastString = 'messenger.COPY_ERROR';
        }
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(this.$translate.instant(toastString))
            .position('bottom center'));
    }
    getLog(sanitize) {
        const browser = this.browserService.getBrowser();
        const config = copyShallow(this.config);
        const userConfig = copyShallow(window['UserConfig']);
        if (sanitize) {
            userConfig.ICE_SERVERS = userConfig.ICE_SERVERS.map((server) => {
                server = copyShallow(server);
                for (const key of ['username', 'credential', 'credentialType']) {
                    if (server[key] !== undefined) {
                        server[key] = `[${server[key].constructor.name}]`;
                    }
                }
                return server;
            });
        }
        const container = {
            config: config,
            userConfig: userConfig,
            browser: browser.description(),
            log: this.logService.memory.getRecords(),
        };
        const replacer = this.logService.memory.getReplacer(sanitize);
        return JSON.stringify(container, replacer, 2);
    }
}
